import { ProductFormVariantSelect } from '../qf/productFormVariantSelect';

export class GBVariantSelect extends ProductFormVariantSelect {
    constructor(product_json, section_id, enable_history) {
        super(product_json, section_id, enable_history);

        this.compare_at_price_el = "[product-max-total]";
        this.saving_total_el = "[product-saving-total]";
        this.sku_el = "[variant-sku]";
        this.stock_locations_el = "[stock-locations]";
        this.countdown_timer_el = "[variant-countdown-timer]";
        this.stock_information_el = "[variant-stock-information]";
        this.stock_locations = "data-stock-locations";
        this.in_store_el = "[variant-in-store]";
        this.in_store_text_el = "[store-online-text]";
        this.in_store_availability = "[variant-in-store]";
        this.in_store_online_text = "data-in-store-online-text";
        this.in_online_only_text = "data-online-only-text";
        this.stock_despatch_text = "data-stock-despatch-text";
        this.data_feed_text = "data-feed-text";
        this.feed_stock_text_el = '[feed-stock-text]';
        this.variant_colour_name = "[variant-colour-name]";

        // Get metafield option names
        this.option_name_1 = this.product_form.dataset.optionNameOne;
        this.option_name_2 = this.product_form.dataset.optionNameTwo;
        this.option_name_3 = this.product_form.dataset.optionNameThree;
    }

    selectCallback(variant, selector) {
        console.log("GB Variant Select");
        // Call the parent class's selectCallback method
        super.selectCallback(variant, selector);

        // Additional function to run when selectCallback is called
        // this.addOptionNameToOptionEls(selector);

        // Set variant prices
        this.setVariantPrices(variant);

        // Set variant SKU
        this.setVariantSKU(variant);

        // Set delivery elements
        this.setDeliveryElements(variant);

        // Set variant colour name
        this.setVariantColourName(variant);

        // Price change complete your look
        this.priceChangeCompleteYourKit(variant);

        // Set submit button state
        this.setSubmitButtonStateCompleteYourKit(variant);
    }

    addOptionNameToOptionEls(selector) {
        const selects = selector.selectors;
        selects.forEach((select,i) => {
            const selectElement = select.element;

            if (selectElement.dataset.processed === "true") {
                return;
            }
            let name = select.name;
            if (this.option_name_1 && i === 0) {
                name = this.option_name_1;
            } else if (this.option_name_2 && i === 1) {
                name = this.option_name_2;
            } else if (this.option_name_3 && i === 2) {
                name = this.option_name_3;
            }

            const options = selectElement.querySelectorAll('option');
            options.forEach((option) => {
                const option_text = option.innerText;
                option.innerText = `${name} - ${option_text}`;
            });

            selectElement.dataset.processed = "true";
        });
    }

    setVariantPrices(variant) {
        if (!variant) {
            return;
        }
        const variant_price = variant.price;
        const variant_compare_at_price = variant.compare_at_price;
        if (this.subtotal_el) {
            const money_format = this.subtotal_el.dataset.moneyFormat;
            const saving_total = this.product_form.querySelector(this.saving_total_el);
            const product_max_total = this.product_form.querySelector(this.compare_at_price_el);

            // Find saving amount
            let saving_amount = 0;
            if (variant_compare_at_price && variant_compare_at_price > variant_price) {
                saving_amount = variant_compare_at_price - variant_price;
            }
            if (variant_compare_at_price) {
                if (!saving_total) {
                    return;
                }
                saving_total.parentNode.style.display = "block";
                saving_total.innerHTML = Shopify.formatMoney(saving_amount, money_format);
                saving_total.setAttribute("data-saving-total", saving_amount);

                product_max_total.parentNode.style.display = "block";
                if (variant_compare_at_price) {
                    product_max_total.innerHTML = Shopify.formatMoney(variant_compare_at_price, money_format);
                    product_max_total.setAttribute("data-max-total", variant_compare_at_price);
                }
            } else {
                if (saving_total) {
                    saving_total.parentNode.style.display = "none";
                }
                if (product_max_total) {
                    product_max_total.parentNode.style.display = "none";
                }
            }
        }
    }

    setVariantSKU(variant) {
        if (!variant) {
            return;
        }
        const sku_el = this.product_form.querySelector(this.sku_el);
        if (sku_el) {
            sku_el.innerHTML = variant.sku;
        }
    }

    setDeliveryElements(variant) {
        if (!variant) {
            return;
        }
        const stock_locations_el = this.product_form.querySelector(this.stock_locations_el);
        if (!variant.available) {
            if (stock_locations_el) {
                stock_locations_el.style.display = "none";
                return;
            }
        }
        if (stock_locations_el) {
            stock_locations_el.style.display = "flex";
            // GET ELEMENTS
            const stock_information_el = stock_locations_el.querySelector(this.stock_information_el);
            const feed_text_el = stock_locations_el.querySelector(this.feed_stock_text_el);
            const countdown_el = stock_locations_el.querySelector(this.countdown_timer_el);
            const stock_available_el = stock_locations_el.querySelector(this.in_store_el);
            const stock_available_text_el = stock_locations_el.querySelector(this.in_store_text_el);

            // TEXT
            const stock_despatch_text = stock_information_el.getAttribute(this.stock_despatch_text);
            const data_feed_text = stock_information_el.getAttribute(this.data_feed_text);
            const in_store_text = stock_available_el.getAttribute(this.in_store_online_text);
            const online_only_text = stock_available_el.getAttribute(this.in_online_only_text);

            const stock_locations_obj = JSON.parse(stock_locations_el.getAttribute(this.stock_locations));
            const variant_stock_locations = stock_locations_obj[variant.id];
            const feed_stock = variant_stock_locations["feed_stock"];
            const shop_location_stock = variant_stock_locations["shop_location"];
            const warehouse_stock = variant_stock_locations["warehouse_stock_record"];

            // IF ONLY FEED STOCK AVAILABLE
            if (shop_location_stock > 0 || warehouse_stock > 0) {
                feed_text_el.innerHTML = stock_despatch_text;
                stock_available_text_el.innerHTML = in_store_text;
                stock_available_el.classList.remove('hide');
                stock_information_el.classList.remove('hide');
                countdown_el.classList.remove('hide');
            } else if (shop_location_stock < 1 && warehouse_stock < 1 && feed_stock > 0) {
                feed_text_el.innerHTML = data_feed_text;
                stock_available_text_el.innerHTML = online_only_text;
                countdown_el.classList.add('hide');
                stock_available_el.classList.remove('hide');
                stock_information_el.classList.remove('hide');
                if (data_feed_text == "") {
                    stock_information_el.classList.add('hide');
                }
            } else if (shop_location_stock < 1 && warehouse_stock < 1 && feed_stock < 1) {
                countdown_el.classList.add('hide');
                stock_available_el.classList.add('hide');
                stock_information_el.classList.add('hide');
            }
        }
    }

    setVariantColourName(variant) {
        if (!variant) {
            return;
        }
        const variant_colour_name = this.product_form.querySelector(this.variant_colour_name);
        if (variant_colour_name) {
            variant_colour_name.innerHTML = variant.option1;
        }
    }

    priceChangeCompleteYourKit(variant) {
        if (!variant) {
            return;
        }
       this.master_select.addEventListener('change', (event) => {
        // get selected option's data-price
        const selected_option = event.target.options[event.target.selectedIndex];
        const selected_option_price = selected_option.getAttribute('data-price');
        const discounted_el = this.product_form.querySelector('[data-discounted-price]');
        const original_price_el = this.product_form.querySelector('[original-price]');
        if (discounted_el && selected_option_price && original_price_el) {
            const discounted_amount = discounted_el.dataset.discountedPrice;
            const discounted_price = selected_option_price * discounted_amount;
            original_price_el.innerHTML = Shopify.formatMoney(selected_option_price, this.money_format);
            discounted_el.innerHTML = Shopify.formatMoney(discounted_price, this.money_format);
        }
       });
    }

    setSubmitButtonStateCompleteYourKit(variant) {
        if (!variant) {
            return;
        }
        this.master_select.addEventListener('change', (event) => {
            const selected_option = event.target.options[event.target.selectedIndex];
            const availability = selected_option.getAttribute('data-availability');
            this.setSubmitButtonState(availability);
        });
    }

}

// Override the global ProductFormVariantSelect reference with the extended class
window.ProductFormVariantSelect = GBVariantSelect;